import {
    FETCH_VIEWER_USER_PREFERENCES_FETCHING,
    FETCH_VIEWER_USER_PREFERENCES_SUCCESS,
    FETCH_VIEWER_USER_PREFERENCES_FAIL,
    UPDATE_VIEWER_USER_PREFERENCES_UPDATING,
    UPDATE_VIEWER_USER_PREFERENCES_SUCCESS,
    UPDATE_VIEWER_USER_PREFERENCES_FAIL,
    SET_VIEWER_USER_PREFERENCES
} from '../../actions/ActionTypes';

/** @typedef {import('reducers/multiSportEdit/types/entity/RootState').RootState} RootState */
/** @typedef {import('reducers/multiSportEdit/types/dto/ViewerUserPreferencesDTO').ViewerUserPreferencesDTO} ViewerUserPreferencesDTO */
/**
 * @typedef {{
 *  viewerUserPreferencesFetching: boolean;
 *  viewerUserPreferencesFetchFail: boolean;
 *  viewerUserPreferencesUpdating: boolean;
 *  viewerUserPreferencesUpdateFail: boolean;
 *  viewerUserPreferences?: ViewerUserPreferencesDTO
 * }} ViewerUserPreferencesState
 */

/** @type {ViewerUserPreferencesState} */
const INITIAL_STATE = {
    viewerUserPreferencesFetching: false,
    viewerUserPreferencesFetchFail: false,
    viewerUserPreferencesUpdating: false,
    viewerUserPreferencesUpdateFail: false,
    viewerUserPreferences: null
};

// ======= Fetching Handlers =======
const fetchViewerUserPreferencesFetching = (state) => {
    return {
        ...state,
        viewerUserPreferencesFetching: true,
        viewerUserPreferencesFetchFail: false
    };
};

const fetchViewerUserPreferencesSuccess = (state, action) => {
    return {
        ...state,
        viewerUserPreferencesFetching: false,
        viewerUserPreferencesFetchFail: false,
        viewerUserPreferences: action.viewerUserPreferences
    };
};

const fetchViewerUserPreferencesFail = (state) => {
    return {
        ...state,
        viewerUserPreferencesFetching: false,
        viewerUserPreferencesFetchFail: true,
        viewerUserPreferences: null
    };
};

// ======= Updating Handlers =======
const updateViewerUserPreferencesUpdating = (state) => {
    return {
        ...state,
        viewerUserPreferencesUpdating: true,
        viewerUserPreferencesUpdateFail: false
    };
};

const updateViewerUserPreferencesUpdateSuccess = (state, action) => {
    return {
        ...state,
        data: action.data,
        viewerUserPreferencesUpdating: false,
        viewerUserPreferencesUpdateFail: false
    };
};

const updateViewerUserPreferencesUpdateFail = (state) => {
    return {
        ...state,
        viewerUserPreferencesUpdating: false,
        viewerUserPreferencesUpdateFail: true
    };
};

// Some user preferences are accessed/updated through multiple endpoints.
// This allows us to keep in sync
const setViewerUserPreferences = (state, action) => {
    return {
        ...state,
        viewerUserPreferences: {
            ...state.viewerUserPreferences,
            ...action.data
        }
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_VIEWER_USER_PREFERENCES_FETCHING]: fetchViewerUserPreferencesFetching,
    [FETCH_VIEWER_USER_PREFERENCES_SUCCESS]: fetchViewerUserPreferencesSuccess,
    [FETCH_VIEWER_USER_PREFERENCES_FAIL]: fetchViewerUserPreferencesFail,
    [UPDATE_VIEWER_USER_PREFERENCES_UPDATING]: updateViewerUserPreferencesUpdating,
    [UPDATE_VIEWER_USER_PREFERENCES_SUCCESS]: updateViewerUserPreferencesUpdateSuccess,
    [UPDATE_VIEWER_USER_PREFERENCES_FAIL]: updateViewerUserPreferencesUpdateFail,
    [SET_VIEWER_USER_PREFERENCES]: setViewerUserPreferences
};

// ======= Default Action =======
export default function viewerUserPreferences(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Selectors =======
/**
 * @param {RootState} state
 * @returns {ViewerUserPreferencesDTO}
 */
export const getViewerUserPreferences = (state) => state.viewerUserPreferences.viewerUserPreferences;

export const isViewerUserPreferencesFetching = (state) => state.viewerUserPreferences.viewerUserPreferencesFetching;

export const didViewerUserPreferencesFetchFail = (state) => state.viewerUserPreferences.viewerUserPreferencesFetchFail;

export const isViewerUserPreferencesUpdating = (state) => state.viewerUserPreferences.viewerUserPreferencesUpdating;

export const didViewerUserPreferencesUpdateFail = (state) =>
    state.viewerUserPreferences.viewerUserPreferencesUpdateFail;
